import React from 'react'
import useAsync from '../../hooks/useAsync'
import ComanServices from '../../services/ComanServices';
import { Card } from '../../components/ui';

function AdminDashboard() {

  const { data, error, isLoading, run } = useAsync(ComanServices.getDashboard);
  return (
    <div className="right_col" role="main">
    <div className="top-sec-heading">
      <h3>Welcome, admin.</h3>
      <p>Hello, here is what happening with your shop today.</p>
    </div>
    <Card padding={false} className="mb-4 overflow-hidden !rounded-[10px] border-[#D6D9FF] p-0 shadow-md dark:!border-slate-700 sm:mb-12">
    <div className="container-box !m-0 !mt-0 !border-0 !bg-transparent !shadow-none dark:!bg-transparent">
      <div className="container-box-top-header">
        <div className="container-box-top-header-left">
          <span><img src="img/chart.svg" alt="" /></span>
          <p>Statistics</p>
        </div>
      </div>
      <div className="container-box-inner">
        <div className="row">
          <div className="col-md-3">
            <div className="g-box g-box1">
              <a href="javascript:void(0)">
                <p>Free User</p>
                <div className="g-box-inner">
                  <h4>{data?.data?.totalUsers - data?.data?.activePlans}</h4>
                  <img src="img/paid-user.svg" alt="" />
                </div>
              </a>
            </div>
          </div>
          <div className="col-md-3">
            <div className="g-box g-box2">
              <a href="javascript:void(0)">
                <p>Paid User</p>
                <div className="g-box-inner">
                  <h4>{data?.data?.activePlans}</h4>
                  <img src="img/free-user.svg" alt="" />
                </div>
              </a>
            </div>
          </div>
          <div className="col-md-3">
            <div className="g-box g-box3">
              <a href="javascript:void(0)">
                <p>Today New User</p>
                <div className="g-box-inner">
                  <h4>{data?.data?.registeredToday}</h4>
                  <img src="img/paid-user.svg" alt="" />
                </div>
              </a>
            </div>
          </div>
          <div className="col-md-3">
            <div className="g-box g-box4">
              <a href="javascript:void(0)">
                <p>Total User</p>
                <div className="g-box-inner">
                  <h4>{data?.data?.totalUsers}</h4>
                  <img src="img/paid-user.svg" alt="" />
                </div>
              </a>
            </div>
          </div>
          <div className="col-md-3">
            <div className="g-box g-box5">
              <a href="javascript:void(0)">
                <p>Today Revenue</p>
                <div className="g-box-inner">
                  <h4>3000</h4>
                  <img src="img/revenue.svg" alt="" />
                </div>
              </a>
            </div>
          </div>
          <div className="col-md-3">
            <div className="g-box g-box6">
              <a href="javascript:void(0)">
                <p>Total Revenue</p>
                <div className="g-box-inner">
                  <h4>20000</h4>
                  <img src="img/revenue.svg" alt="" />
                </div>
              </a>
            </div>
          </div>
          <div className="col-md-3">
            <div className="g-box g-box7">
              <a href="javascript:void(0)">
                <p>Expired User</p>
                <div className="g-box-inner">
                  <h4>{data?.data?.expiredPlans}</h4>
                  <img src="img/revenue.svg" alt="" />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    </Card>
    <div className="container-box qr-code-box">
      <div className="container-box-top-header">
        <div className="container-box-top-header-left">
          <span><img src="img/chart2.svg" alt="" /></span>
          <p>Loyal User Graph and List</p>
        </div>
      </div>
      <div className="container-box-inner mt-3 pt-4">
        <div className="qr-code-status mt-4">
          <img src="img/graph.svg" />
        </div>
      </div>
    </div>
    <div className="container-box qr-code-box">
      <div className="container-box-top-header">
        <div className="container-box-top-header-left">
          <span><img src="img/chart2.svg" alt="" /></span>
          <p> Expired User Graph and List</p>
        </div>
      </div>
      <div className="container-box-inner mt-3 pt-4">
        <div className="qr-code-status mt-4">
          <img src="img/graph.svg" />
        </div>
      </div>
    </div>
  </div>
  )
}

export default AdminDashboard